import React from "react";
import OnIcon from "../../svgs/collections/OnIcon";
import OffIcon from "../../svgs/collections/OffIcon";
import EditIcon from "../../svgs/collections/EditIcon";

const IndustryCardDetailed = ({
  item,
  onShowClicked,
  onEditClicked,
  isShowLoading,
  isEditLoading,
}) => {
  return (
    <div
      className={`industryCard industryCard--detailed ${
        item?.show ? "industryCard--enabled" : "industryCard--disabled"
      }`}
    >
      <div className="industryCard__header">
        <div className="industryCard__logo">
          {item?.logoStorage ? (
            <img src={item?.logoStorage} alt={item?.name} />
          ) : (
            <div className="industryCard__logo__placeholder">
              <span>{item?.name?.charAt(0)?.toUpperCase()}</span>
            </div>
          )}
        </div>
        <div className="industryCard__title">
          <h3>{item?.name}</h3>
        </div>
        <div className="industryCard__actions">
          <button
            onClick={() => onShowClicked(item)}
            disabled={isShowLoading}
            className={`industryCard__actions__show ${
              item?.show
                ? "industryCard__actions__show--enabled"
                : "industryCard__actions__show--disabled"
            }`}
          >
            {item?.show ? <OnIcon /> : <OffIcon />}
          </button>
          <button
            onClick={() => onEditClicked(item)}
            disabled={isEditLoading}
            className={`industryCard__actions__edit ${
              item?.show
                ? "industryCard__actions__edit--enabled"
                : "industryCard__actions__edit--disabled"
            }`}
          >
            <EditIcon />
          </button>
        </div>
      </div>
      <div className="industryCard__info">
        <span>223 companies</span>
        <span>412 partners</span>
        <span>254 jobs</span>
        <span>313 cases studies</span>
        <span>278 devs</span>
      </div>
    </div>
  );
};

export default IndustryCardDetailed;
